import { FC } from 'react';
import { translate } from 'translations';
import { useNavigate } from 'react-router-dom';
import { Divider, Icon } from 'learning-panel-components';
import styles from './quizCard.module.scss';

const QuizCard: FC<QuizCardProps> = (props: QuizCardProps) => {
    const { quizId, numberOfQuestions, incorrectQuestionsAllowed, attemptsAllowed, status, courseCompleted } = props;
    const navigate = useNavigate();

    const openQuiz = () => {
        navigate(`/app/quiz/?quiz=${quizId}`);
    };

    const isClickableQuiz = status === 'not_completed' && courseCompleted;

    return (
        <div className={styles['quiz-card-wrapper']}>
            {(status === 'attempts_exceeded' || status === 'completed') && (
                <div className={styles.tag}>{translate(status === 'completed' ? 'Completed' : 'AllAttemptsUsed')}</div>
            )}
            <div
                className={styles.card}
                onClick={() => (!isClickableQuiz ? undefined : openQuiz())}
                style={{
                    cursor: !isClickableQuiz ? 'default' : 'pointer',
                    opacity: !isClickableQuiz ? 0.5 : 1
                }}
            >
                <div className={styles.top}>
                    <img src={`${process.env.PUBLIC_URL}/images/quiz.svg`} className={styles.img} alt="quizCard" />
                </div>
                <div className={styles.bottom}>
                    <div className={styles['quiz-title']}>
                        <div className={styles.title}>
                            <Icon name="assessmentIconLearningPanel" className={styles['type-icon']} />
                            <div className={styles.text}>{translate('CERTIFICATE TEST')}</div>
                        </div>
                    </div>
                    <div className={styles['details-wrapper']}>
                        <div className={styles.details}>
                            <div className={styles.text}>{numberOfQuestions} Questions</div>
                        </div>
                        <Divider orientation="vertical" className={styles.divider} color="rgba(98, 98, 98, 0.3)" />
                        <div className={styles.incorrect}>
                            <Icon name="incorrect" className={styles['type-icon']} />
                            <div className={styles.text}>{incorrectQuestionsAllowed}</div>
                        </div>
                        <Divider orientation="vertical" className={styles.divider} color="rgba(98, 98, 98, 0.3)" />
                        <div className={styles.attempts}>
                            <Icon name="rounds" className={styles['type-icon']} style={{ marginTop: '0.2rem' }} />
                            <div className={styles.text}>{attemptsAllowed}</div>
                        </div>
                        <Divider orientation="vertical" className={styles.divider} color="rgba(98, 98, 98, 0.3)" />
                        <div className={styles.certificate}>
                            <Icon name="certificate" className={styles['type-icon']} style={{ marginTop: '0.2rem' }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuizCard;

interface QuizCardProps {
    quizId: number;
    numberOfQuestions: number;
    incorrectQuestionsAllowed: number;
    attemptsAllowed: number;
    status?: 'completed' | 'attempts_exceeded' | 'not_completed';
    courseCompleted: boolean;
}
